import React, { useState, useEffect } from "react";
import { Col, Row, Modal, Form as AntForm } from "antd";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import styles from "assets/css/modals.module.css";
import { AutoSubmit, OtpInputComponent } from "components/Authentication/Common/OtpInput";
import { resendCounterTime } from "constant/messageConstants";

const VerificationModal = props => {
  const { visible, onCancel, onSubmit, title, resendOtp } = props;
  const [resendAlert, setResendAlert] = useState(false);
  const [counter, setCounter] = useState(resendCounterTime);

  const startCounter = () => {
    if (counter > 0) setCounter(counter - 1);
  };

  useEffect(() => {
    startCounter();
    setResendAlert(true);
  }, []);

  useEffect(() => {
    if (counter < resendCounterTime && counter > 0) {
      setTimeout(() => setCounter(counter - 1), 1000);
    } else if (counter === 0) {
      setCounter(resendCounterTime);
      setResendAlert(false);
    }
  }, [counter]);

  return (
    <Modal
      visible={visible}
      title={title}
      onCancel={onCancel}
      closeIcon={
        <div className={`btn ${styles.modalCloseBtn}`} type="button">
          <i className="fas fa-times"></i>
        </div>
      }
      footer={null}
      centered
      destroyOnClose
      width={400}
      maskStyle={{
        background: "linear-gradient(135deg, #00000050, #107c9850)"
      }}
    >
      <Formik
        enableReinitialize
        initialValues={{ otp: "" }}
        onSubmit={async (values, { setSubmitting, setFieldError, setFieldValue, setFieldTouched }) => {
          try {
            await onSubmit(values);
            setSubmitting(false);
          } catch (error) {
            const message = (typeof error === "string" && error) || error?.message || "Invalid OTP code";
            setFieldValue("otp", "", false);
            setFieldTouched("otp", true, false);
            setFieldError("otp", message);
            setSubmitting(false);
          }
        }}
        validationSchema={Yup.object({
          otp: Yup.string()
            .min(6, "Invalid Code")
            .max(6, "Invalid Code")
            .required("Code is required")
        })}
      >
        {({ values, errors, setFieldValue, touched, handleSubmit, isSubmitting }) => (
          <Form onSubmit={handleSubmit} className="my-3">
            <AutoSubmit />
            <AntForm.Item validateStatus={errors.otp && touched.otp ? "error" : ""} colon={false} help="" className="mb-2">
              <OtpInputComponent value={values.otp} onChange={otp => setFieldValue("otp", otp)} isDisabled={isSubmitting} />
            </AntForm.Item>
            {errors.otp && touched.otp ? (
              <div className="text-center text-danger mb-3" style={{ fontSize: 13 }}>
                {errors.otp}
              </div>
            ) : (
              <div className="mb-3" style={{ height: 20 }} />
            )}
            <Row className="mb-4" type="flex" align="middle">
              <Col span={24} className="text-center">
                {resendAlert ? (
                  <span className="text-info-color pe-auto fw-bold">
                    OTP code expires in{" "}
                    <button
                      role="none"
                      className="rounded ms-1 text-center border-0 text-info-color"
                      style={{
                        background: "#149cbe40",
                        fontSize: "13px",
                        width: "25px",
                        height: "25px"
                      }}
                    >
                      {counter}
                    </button>
                  </span>
                ) : (
                  <span
                    className="text-info-color pe-auto text-decoration-underline"
                    type="button"
                    onClick={e => {
                      e.preventDefault();
                      resendOtp({
                        setCount: setCounter,
                        setAlert: setResendAlert
                      });
                    }}
                  >
                    {" "}
                    Resend OTP
                  </span>
                )}
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default VerificationModal;
